module.exports = __webpack_public_path__ + "assets/img/zfb.312cea63.png";